<template>
  <article class="contents-content">
    <div class="contents-content__content">
      <div class="content-in-area">
        <h1 class="content__title">계정관리</h1>
        <v-container>
          <v-row>
            <nav class="content-left-menu">
              <transition name="fade">
                <div v-if="userList && userList.length > 0">
                  <ul
                    class="content-menu-list"
                    ref="contentMenu"
                  >
                    <li
                      v-for="(user, idx) in userList"
                      :key="user.id"
                      :class="['content-menu__item', {'is--active' : activeIndex === idx}]"
                      @click="setCurrentUser(user)"
                    >
                      <strong
                        class="menu__item-main"
                        @click="selectMainItem(idx)"
                      >
                        {{ user.name }}
                      </strong>
                    </li>
                  </ul>
                </div>
                <p class="content--empty" v-if="userList && userList.length === 0">등록된 사용자가 없습니다.</p>
              </transition>
            </nav>
            <div class="content--has-menu">
              <v-card outlined class="content__content">
                <v-card-text>
                  <v-form
                    ref="form"
                    v-if="user && user.uid > 0"
                  >
                    <v-container>
                      <v-row class="pa-2">
                        <v-col cols="12" class="pa-0">
                          <v-text-field
                            v-model="user.name"
                            prepend-icon="person"
                            label="이름"
                            readonly
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-text-field
                            prepend-icon="email"
                            v-model="user.email"
                            label="이메일"
                            readonly
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="3">
                          <strong class="checkbox__title">
                            앱 정보 관리
                          </strong>
                        </v-col>
                        <v-col cols="9">
                          <v-row justify="start">
                            <v-checkbox
                              dense
                              v-model="user.author.readInfo"
                              label="읽기"
                              hide-details
                              class="ma-0 mr-6 pa-0"
                            ></v-checkbox>
                            <v-checkbox
                              dense
                              v-model="user.author.writeInfo"
                              label="쓰기"
                              hide-details
                              class="ma-0 pa-0"
                            ></v-checkbox>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="3">
                          <strong class="checkbox__title">
                            주보 관리
                          </strong>
                        </v-col>
                        <v-col cols="9">
                          <v-row justify="start">
                            <v-checkbox
                              dense
                              v-model="user.author.readWeekly"
                              label="읽기"
                              hide-details
                              class="ma-0 mr-6 pa-0"
                            ></v-checkbox>
                            <v-checkbox
                              dense
                              v-model="user.author.writeWeekly"
                              label="쓰기"
                              hide-details
                              class="ma-0 pa-0"
                            ></v-checkbox>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="3">
                          <strong class="checkbox__title">
                            셔틀버스 관리
                          </strong>
                        </v-col>
                        <v-col cols="9">
                          <v-row justify="start">
                            <v-checkbox
                              dense
                              v-model="user.author.readBus"
                              label="읽기"
                              hide-details
                              class="ma-0 mr-6 pa-0"
                            ></v-checkbox>
                            <v-checkbox
                              dense
                              v-model="user.author.writeBus"
                              label="쓰기"
                              hide-details
                              class="ma-0 pa-0"
                            ></v-checkbox>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="3">
                          <strong class="checkbox__title">
                            주차장 관리
                          </strong>
                        </v-col>
                        <v-col cols="9">
                          <v-row justify="start">
                            <v-checkbox
                              dense
                              v-model="user.author.readParking"
                              label="읽기"
                              hide-details
                              class="ma-0 mr-6 pa-0"
                            ></v-checkbox>
                            <v-checkbox
                              dense
                              v-model="user.author.writeParking"
                              label="쓰기"
                              hide-details
                              class="ma-0 pa-0"
                            ></v-checkbox>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="3">
                          <strong class="checkbox__title">
                            계정관리
                          </strong>
                        </v-col>
                        <v-col cols="9">
                          <v-row justify="start">
                            <v-checkbox
                              dense
                              v-model="user.author.readAuth"
                              label="읽기"
                              hide-details
                              class="ma-0 mr-6 pa-0"
                            ></v-checkbox>
                            <v-checkbox
                              dense
                              v-model="user.author.writeAuth"
                              label="쓰기"
                              hide-details
                              class="ma-0 pa-0"
                            ></v-checkbox>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col class="text-center mt-2">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.writeAuth"
                            class="mt-4"
                            color="primary"
                            large
                            rounded
                            depressed
                            @click="onSubmit">
                            적용하기
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                  <p v-else class="content--empty">선택된 계정이 없습니다.</p>
                </v-card-text>
              </v-card>
            </div>
          </v-row>
        </v-container>
      </div>
    </div>
  </article>
</template>

<script>
import { user } from '../api'
import eventBus from '../utils/eventBus'
export default {
  components: {
  },
  data: () => ({
    item: null,
    userList: null,
    user: {
      uid: 0,
      name: '',
      email: '',
      phone: '',
      author: {
        readAuth: false,
        readBus: false,
        readInfo: false,
        readParking: false,
        readWeekly: false,
        writeAuth: false,
        writeBus: false,
        writeInfo: false,
        writeParking: false,
        writeWeekly: false
      }
    },
    mode: 'UPDATE',
    activeIndex: null
  }),
  created () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      const { data } = await user.list()
      this.userList = data
    },
    async updateAuth () {
      try {
        eventBus.$emit('showLoading')
        await user.setAuthorization(this.user.uid, this.user.author)
        eventBus.$emit('alert', { active: true, text: '수정 되었습니다.' })
        await this.fetchList()
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러!' })
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    setCurrentUser (user) {
      this.user = { ...user }
      this.mode = 'UPDATE'
    },
    selectMainItem (index) {
      this.activeIndex = index
    },
    onSubmit () {
      this.updateAuth()
    }
  }
}
</script>

<style lang="scss">
  .theme--light {
    &.left {
      margin-top: 70px;
      left: 256px;
      /*box-shadow: 2px 4px 6px 0 rgba(0, 0, 0, 0.12);*/
      &.v-navigation-drawer:not(.v-navigation-drawer--floating) {
        .v-navigation-drawer__border {
          background: none;
        }
      }
    }
  }
  .checkbox__title {
    color: #454545;
    letter-spacing: -0.5px;
    font-size: 15px;
    font-weight: 400;
  }
</style>
